import { SvgIconTypeMap } from '@material-ui/core';
import { OverridableComponent } from '@material-ui/core/OverridableComponent';
import SvgIcon from '@material-ui/icons/AccountBalance';
import { EntityListButton } from 'components/Layout/components/AsideMenuList/style';
import React from 'react';
import SVG from 'react-inlinesvg';
import { useHistory } from 'react-router';
import { getPath } from 'utils/path';

type AsideMenuIconProps = {
  icon: AsideListIcon;
  active: boolean;
  onClick: () => void;
};

export type AsideListIcon = {
  label: string;
  description?: string;
  routePath: string;
  muiIcon?: OverridableComponent<SvgIconTypeMap<Record<string, unknown>, 'svg'>> & {
    muiName: string;
  };
  svgIcon?: string;
};

const AsideMenuIcon = ({ icon, active, onClick }: AsideMenuIconProps) => {
  const history = useHistory();

  const handleClick = () => {
    history.push(getPath([icon.routePath]));
  };

  return (
    <li
      className={`menu-item menu-item-submenu px-3 menu-item-open ${active && 'menu-item-active '}`}
      data-menu-toggle="hover"
      onClick={onClick}
    >
      <EntityListButton
        className="menu-link my-1 menu-toggle"
        style={{
          paddingTop: '5px',
          paddingBottom: '5px',
          paddingLeft: '30px',
        }}
        onClick={handleClick}
      >
        <span className="svg-icon menu-icon m-2" style={{ color: '#576688' }}>
          {icon.muiIcon && <SvgIcon component={icon.muiIcon} />}
          {icon.svgIcon && <SVG src={icon.svgIcon} />}
        </span>
        <span className="menu-text">
          <div className={`header header-active`}>{icon.label}</div>
          <div className="sub-header">{icon.description}</div>
        </span>
      </EntityListButton>
    </li>
  );
};

export default AsideMenuIcon;
